let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5yu8n")).then(() => parcelRequire('fWqMV'));